<template>
    <div class="router-view-wrapper">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'RouterViewWrapper',
};
</script>

<style scoped lang="less">
.router-view-wrapper:focus-visible {
    outline: none;
}
</style>